import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'ポイント還元率とは何ですか？',
      answer: 'ポイント還元率とは、カード利用金額に対して何％分のポイントが貯まるかを示す指標です。例えば、還元率1%のカードで10,000円使うと、100円分のポイントが貯まります。還元率が高いほど、お得にポイントを貯められます。'
    },
    {
      question: '還元率が高いカードは年会費も高いですか？',
      answer: 'いいえ、必ずしもそうではありません。三井住友カード（NL）やリクルートカードなど、年会費無料でも高還元率のカードは多数あります。年会費無料で基本還元率1%以上のカードを選べば、維持コストゼロで効率的にポイントを貯められます。'
    },
    {
      question: '複数のクレジットカードを持つメリットはありますか？',
      answer: 'はい、大きなメリットがあります。利用シーンに応じて最も還元率が高いカードを使い分けることで、ポイント還元を最大化できます。例えば、コンビニでは三井住友カード（NL）、ネット通販では国際ブランド系カード Wというように使い分けると効率的です。年会費無料のカードなら、複数持ちでも維持コストはかかりません。'
    },
    {
      question: '特約店とは何ですか？',
      answer: '特約店とは、カード会社が提携している店舗やサービスのことで、通常よりも高いポイント還元率が適用されます。例えば、三井住友カード（NL）では対象のコンビニ・飲食店で最大7%還元、国際ブランド系カード WではAmazonで最大5.5%還元など、特約店での利用が非常にお得です。'
    },
    {
      question: 'ポイントの有効期限はありますか？',
      answer: 'はい、多くのポイントには有効期限があります。カードによって異なりますが、一般的に1〜3年程度です。また、期間限定ポイントは数週間〜数ヶ月と短い場合もあります。ポイントを無駄にしないよう、定期的に残高と有効期限を確認し、計画的に使いましょう。'
    },
    {
      question: '還元率を最大化するコツはありますか？',
      answer: '3つのコツがあります。①特約店を積極的に活用する、②携帯料金や光熱費などの固定費を高還元カードに集約する、③利用シーンに応じて複数のカードを使い分ける。これらを実践することで、年間数万円分のポイントを貯めることも可能です。'
    },
    {
      question: 'ポイントはどのように使うのがお得ですか？',
      answer: '最もお得なのは、交換レートが1ポイント=1円以上の使い道です。キャッシュバック、Amazonギフト券、日常の買い物での利用などがおすすめです。マイルへの交換は旅行好きな方には魅力的ですが、レートが低い場合もあるので注意が必要です。'
    },
    {
      question: '学生や主婦でも高還元率カードは作れますか？',
      answer: 'はい、作れます。三井住友カード（NL）、大手ECモール系カード、リクルートカードなどは、学生や主婦の方でも申込み可能です。安定した収入がなくても、世帯収入や配偶者の収入で審査される場合があります。年会費無料のカードから始めるのがおすすめです。'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <h3 className="text-3xl font-bold text-center mb-4 text-[#003366]">
          よくある質問
        </h3>
        <p className="text-center text-gray-600 mb-12">
          高還元率クレジットカードに関するよくある質問にお答えします
        </p>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl overflow-hidden border-2 border-gray-200 hover:border-[#FFB800] transition-all"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <div className="flex items-start gap-4 flex-1">
                  <div className="w-8 h-8 bg-[#FFB800] rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">Q</span>
                  </div>
                  <h4 className="text-lg font-bold text-[#003366] pt-1">{faq.question}</h4>
                </div>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-[#003366] transition-transform flex-shrink-0 w-6 h-6 flex items-center justify-center ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5">
                  <div className="flex items-start gap-4 ml-0">
                    <div className="w-8 h-8 bg-[#14B8A6] rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-white font-bold">A</span>
                    </div>
                    <p className="text-gray-700 leading-relaxed pt-1">{faq.answer}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-[#FFB800] to-[#FFA000] rounded-xl p-8 text-center">
          <h4 className="text-2xl font-bold text-white mb-4">
            まだ疑問がありますか？
          </h4>
          <p className="text-white mb-6">
            各カードの詳細ページで、さらに詳しい情報をご確認いただけます。
          </p>
          <a
            href="#ranking"
            className="inline-block bg-white text-[#FFB800] px-8 py-3 rounded-lg font-bold hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap shadow-lg"
          >
            おすすめカードを見る
          </a>
        </div>
      </div>
    </section>
  );
}
